import React from "react";
import { useSelector } from "react-redux";
import { CustomerPortalState } from "../../store";
import { Loader } from "../../../Loader/Loader";
import { Route, Routes } from "react-router-dom";
import FeatureSets from "./FeatureSets/FeatureSets";
import { FeatureSetDetails as FeatureSet } from "./FeatureSets/FeatureSet";
import MediaCollections from "../CMS/MediaCollections/MediaCollections";
import { MediaCollection } from "../CMS/MediaCollections/MediaCollection";

const Offerings: React.FC = () => {
  const isLoading = useSelector(
    (state: CustomerPortalState) => state.offerings.isLoading
  );

  return (
    <>
      <Loader loading={isLoading} />
      <Routes>
        <Route path="feature-sets" element={<FeatureSets />} />
        <Route path="feature-sets/:id" element={<FeatureSet />} />
        <Route path="media-collections" element={<MediaCollections />} />
        <Route path="media-collections/:id" element={<MediaCollection />} />
      </Routes>
    </>
  );
};

export default Offerings;
